import { useEffect, useState } from "react";
import patientSpecialPackageService from "../patientSpecialPackageService";
import { getErrorMsg } from "@base/helpers/common";

const useCalCulateFee = () => {
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");
  const [data, setData] = useState({
    actual_fee: 0,
    discount: 0,
    other_fee: 0,
    tax: 0,
    total_fee: 0,
  });

  const handleFee = async (body: any) => {
    setLoading(true);
    try {
      const result = await patientSpecialPackageService.calculateFee(body);
      setData(result.data);
      return result;
    } catch (error) {
      setLoading(false);
      setError(getErrorMsg(error));
    } finally {
      setLoading(false);
    }
  };

  return {
    isLoading,
    error,
    data,
    handleFee,
  };
};

export default useCalCulateFee;
